import apiSlice from "state/api/apiSlice";

export const tasksApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    /* GET */
    getTaskStatusById: builder.query({
      query: ({ communityId, taskId, groupTask }) => ({
        url: `/communities/${communityId}/tasks/${taskId}?group_task=${groupTask}`,
        method: "GET",
        validateStatus: (response, result) => response.status === 200 && !result?.isError,
      }),
    }),
  }),
});

export const { useGetTaskStatusByIdQuery } = tasksApiSlice;
